// extracted by mini-css-extract-plugin
export default {"buttonWrapper":"GreenButton_buttonWrapper__3UpVL","spin":"GreenButton_spin__QX0L1"};